export const convertDataLocation = (originalData: any, defaultTestKits: any) => {
    const converted = originalData.sampleLocationAllVOs.map((location: any) => {
        const testKitDescriptors = location.testKitIDs.map((testKitId: any) => {
            const defaultKit = defaultTestKits.findIndex((dKit: any)=> dKit.id ===  testKitId)
            const fieldDescriptors = defaultTestKits[defaultKit];
            const testKitInputDescriptorVOs: any[] = [];
            const testKitOutputDescriptorVOs: any[]  = [];
            fieldDescriptors?.fieldDescriptorAllVOs?.forEach((voS:any, index: number) => {
                if (voS.type !== "Output") {
                    testKitInputDescriptorVOs.push({
                        id: voS?.id,
                        inputName: voS?.outputName,
                        unit: voS?.unit,
                        minimum: 5000,
                        toPrev: true,
                        readPM: voS.readPM,
                        isRequired: voS.isRequired,
                        defaultValue: voS.defaultValue,
                        sortorder: index,
                        inputId: voS?.outputId,
                        type: voS?.type,
                    });
                } else {
                    const outputObject : any =  {
                        id: voS?.id,
                        outputName: voS?.outputName,
                        unit: voS?.unit,
                        minimum: 5000,
                        sortorder: index,
                        outputId: voS?.outputId,
                        type: voS?.type,
                        hide: voS?.hidden,
                        formula: voS?.formula,
                        minVal: 0,
                        maxVal: 0,
                    }
                    if(voS?.loLoAlarmValue){
                       
                        outputObject["loLoValue"] = voS?.loLoAlarmValue || null
                        outputObject["loValue"] = voS?.loAlarmValue || null
                    }
                    if(voS?.hiHiAlarmValue){
                        outputObject["hiHiValue"] = voS?.hiHiAlarmValue || null
                    outputObject["hiValue"] = voS?.hiAlarmValue || null
                    }
                    testKitOutputDescriptorVOs.push(outputObject);
                }
            });
            return {
                testKitName: defaultTestKits[defaultKit].testKitName,
                id: testKitId,
                testKitInputDescriptorVOs: [...testKitInputDescriptorVOs || []],
                testKitOutputDescriptorVOs:[...testKitOutputDescriptorVOs || []],
                outPutAlarmsVos: [...testKitOutputDescriptorVOs || []],
                riskScoreVO: fieldDescriptors.riskScoreVO
            };
        });

        return {
            id: location?.id,
            name: location?.name,
            sortOrder: location?.sortOrder || 999,
            dataPoints: [],
            testKitDescriptors: testKitDescriptors || []
        };
    });

    return converted;
}

export function mapCacheDescriptorsToSimpleDescriptors (location: {id: number, name: string, testKitIDs: number[], testKitDescriptors: any[]}, defaultKits: any) {

    let testKitDescriptors: any[] = [];

    location.testKitIDs.forEach(kitID => {
        let testKit = defaultKits.find((kit: any) => kit.id === kitID);
        testKit.fieldDescriptorAllVOs.forEach((field: any) => {
            field["inputId"] = field.outputId;
            field["inputName"] = field.outputName;
        })
        testKitDescriptors.push(testKit);
    });

    location["testKitDescriptors"] = testKitDescriptors;
    
    return location;

}